import { render, staticRenderFns } from "./ControlCheck.vue?vue&type=template&id=65a12a5d&scoped=true&"
import script from "./ControlCheck.vue?vue&type=script&lang=js&"
export * from "./ControlCheck.vue?vue&type=script&lang=js&"
import style0 from "./ControlCheck.vue?vue&type=style&index=0&id=65a12a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a12a5d",
  null
  
)

export default component.exports